import { pathOr } from 'ramda';
import { MORTGAGE_PROMO_TYPES } from '../../constants/promos';
import { IPromo } from '../../types/newbuilding/promos';
import { IApplicationState } from '../../types/redux';

export const selectMortgagePromos = (state: IApplicationState) => {
  const promos: IPromo[] = pathOr([], ['newbuilding', 'promoInfos'], state);

  if (!promos.length) {
    return [];
  }

  return promos.filter(promo => MORTGAGE_PROMO_TYPES.includes(promo.promoType));
};
